import { useModal, create } from '@ebay/nice-modal-react';
import { useMemo } from 'react';

import { EditProfilePopupController } from './edit-profile-popup.controller';

const EditProfilePopupModal = create(EditProfilePopupController);

export const useEditProfilePopup = () => {
  const { show } = useModal(EditProfilePopupModal);

  return useMemo(() => ({ open: show }), [show]);
};
